import React, { useState } from "react";
import { useQuery, useMutation, gql } from "@apollo/client";
import { Dialog, Checkbox, Spinner, Pane, Text, toaster } from "evergreen-ui";
import { FieldBtn } from "../../dues/dues.style";

const GET_DUES_BY_PROPERTY = gql`
  query Dues_getByProperty($propertyId: ID!) {
    dues_getByProperty(propertyId: $propertyId) {
      _id
      title
      startDate
      isStopped
      isStarted
    }
  }
`;

const REMOVE_DUES_FROM_PROPERTIES = gql`
  mutation Dues_removeProperties($dueIds: [ID!]!, $propertyIds: [ID!]!) {
    dues_removeProperties(dueIds: $dueIds, propertyIds: $propertyIds) {
      code
      success
      error
    }
  }
`;

const RemoveDuesModal = ({ propertyIds }) => {
  const [isDialogShown, setIsDialogShown] = useState(false);
  const [selectedDues, setSelectedDues] = useState([]);

  // Query to fetch dues by property
  const { loading, data } = useQuery(GET_DUES_BY_PROPERTY, {
    variables: { propertyId: propertyIds[0] }, // Assuming single property
    skip: !isDialogShown,
  });

  const [removeDuesFromProperties, { loading: mutationLoading }] = useMutation(
    REMOVE_DUES_FROM_PROPERTIES,
    {
      onCompleted: (response) => {
        if (response.dues_removeProperties.success) {
          toaster.success("Dues removed successfully!");
          setIsDialogShown(false);
          setSelectedDues([]);
          window.location.reload();
        } else {
          toaster.danger(response.dues_removeProperties.error || "Failed to remove dues.");
        }
      },
      onError: (error) => {
        toaster.danger(error.message);
      },
    }
  );

  const handleCheckboxChange = (dueId) => {
    setSelectedDues((prev) =>
      prev.includes(dueId) ? prev.filter((id) => id !== dueId) : [...prev, dueId]
    );
  };

  const handleSubmit = () => {
    if (selectedDues.length === 0) {
      toaster.warning("No dues selected for removal.");
      return;
    }

    removeDuesFromProperties({ variables: { dueIds: selectedDues, propertyIds } });
  };

  return (
    <Pane>
      <FieldBtn onClick={() => setIsDialogShown(true)} className="waves-effect waves-light btn-flat">
        Remove Dues
      </FieldBtn>

      <Dialog
        isShown={isDialogShown}
        title="Select Dues to Remove from Property"
        onCloseComplete={() => setIsDialogShown(false)}
        confirmLabel="Remove Selected Dues"
        isConfirmLoading={mutationLoading}
        onConfirm={handleSubmit}
        cancelLabel="Cancel"
      >
        {loading ? (
          <Spinner />
        ) : (
          <Pane>
            {data?.dues_getByProperty?.length > 0 ? (
              data.dues_getByProperty.map((due) => (
                <Pane key={due._id} marginBottom={16}>
                  <Checkbox
                    label={
                      <Pane>
                        <Text fontWeight={600}>{due.title}</Text>
                        <Text color="muted" size={300}>
                          {" "}
                          (Start: {new Date(due.startDate).toLocaleDateString()})
                          {due.isStarted ? " - Started" : due.isStopped ? " - Stopped" : ""}
                        </Text>
                      </Pane>
                    }
                    checked={selectedDues.includes(due._id)}
                    onChange={() => handleCheckboxChange(due._id)}
                  />
                </Pane>
              ))
            ) : (
              <Text>No dues assigned to this property.</Text>
            )}
          </Pane>
        )}
      </Dialog>
    </Pane>
  );
};

export default RemoveDuesModal;
